// extracted by mini-css-extract-plugin
module.exports = {"more":"_171fa3","header":"_1ba9c2","root":"_d32cd0","content":"_2940ec","title":"_cba18d","phone":"_a93fa9","avatar":"_e2aa16"};